module.exports = __webpack_public_path__ + "media/images/common/hakuoshi_silver-c5d9348b230b114e15fd3b08b507b61f.jpg";